import Request from '@/utils/request'

// 低频小额充值活动
export function lowSmallRechargeApi () {
  return Request({
    url: '/api/v2/app/shop/activity/12/cfg',
    method: 'get'
  })
}
